import { useContext } from "react";
import { useMutation, useQuery, useQueryClient } from "react-query";
import axios from "axios";
import { MisAPI } from "../../../constants/API";
import { commonHeaders } from "../../../constants/HeadersAPI";
import { defaultSuccessMessage } from "../../../constants/alertText";
import { AlertContext } from "../../../context/AlertProvider";
import { AlertType } from "../../../types/enums";
import {
  EmergencyCodeDto,
  EmergencyCodeRequest,
} from "../../../types/Mis/MisTypes";

export const useGetEmergencyCodes = (branchId: number | null) => {
  return useQuery(
    ["misEmergencyCodes", branchId],
    async () => {
      const { data } = await axios.get<EmergencyCodeDto[]>(
        MisAPI.getEmergencyCodes(branchId!),
        commonHeaders(),
      );
      return data;
    },
    { enabled: branchId != null && branchId > 0 },
  );
};

export const useSaveEmergencyCode = (branchId: number | null) => {
  const queryClient = useQueryClient();
  const context = useContext(AlertContext);
  return useMutation(
    (input: { id?: number; payload: EmergencyCodeRequest }) => {
      if (input.id) {
        return axios.put<EmergencyCodeDto>(
          MisAPI.updateEmergencyCode(branchId!, input.id),
          input.payload,
          commonHeaders(),
        );
      }
      return axios.post<EmergencyCodeDto>(
        MisAPI.createEmergencyCode(branchId!),
        input.payload,
        commonHeaders(),
      );
    },
    {
      onSuccess: () => {
        queryClient
          .invalidateQueries(["misEmergencyCodes", branchId])
          .then(() =>
            context?.setAlert({
              type: AlertType.Success,
              message: defaultSuccessMessage,
            }),
          );
      },
    },
  );
};
